module.exports = __webpack_public_path__ + "static/media/bgImage.f60e9825.png";